import type { ReactNode } from 'react';
import { copyToClipboard } from '@gonfalon/dom/copyToClipboard';
import type { TooltipProps } from '@launchpad-ui/components';
import { Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import { PressResponder } from '@react-aria/interactions';

type CopyToClipboardProps = {
  onCopy?: () => void;
  children: ReactNode;
  text: string;
  /** Toast announced after a copy. */
  message?: string;
  tooltip?: string;
  showTooltip?: boolean;
  tooltipPlacement?: TooltipProps['placement'];
};

export const CopyToClipboard = ({
  onCopy,
  children,
  text,
  message = 'Copied!',
  tooltip = 'Copy to clipboard',
  showTooltip = true,
  tooltipPlacement = 'bottom',
}: CopyToClipboardProps) => {
  const handlePress = async () => {
    await copyToClipboard(text, message);
    if (onCopy) {
      onCopy();
    }
  };

  return (
    <TooltipTrigger>
      <PressResponder onPress={handlePress}>{children}</PressResponder>
      {showTooltip && <Tooltip placement={tooltipPlacement}>{tooltip}</Tooltip>}
    </TooltipTrigger>
  );
};
